

const buttons = document.querySelectorAll('.play-button');

buttons.forEach(button => {
	button.addEventListener('click', openVideoModal);
});

/**
 * Opens the Preview Video Modal when the Play button for that specific Video-Text Card
 *
 * @param event
 */
function openVideoModal(event) {
	event.preventDefault();

	const videoTextCard = event.target.closest('.wp-block-zp4-video-text-card');

	if (videoTextCard) {
		const modal = videoTextCard.querySelector('.modal');

		if (modal) {
			modal.style.display = 'block';
			modal.setAttribute('aria-hidden', 'false');
			document.body.style.overflow = 'hidden';
			trapFocus(modal);
			setupModalCloseHandlers(modal);
		} else {
			console.error('No modal found within the video text card.');
		}
	} else {
		console.error('No parent with the class .wp-block-zp4-video-text-card found.');
	}
}


/**
 * Closes the Modal
 *
 * @param modal
 */
function closeModal(modal) {

	modal.style.display = 'none';
	modal.setAttribute('aria-hidden', 'true');
	document.body.style.overflow = '';
	pauseAllYouTubeVideos();
}

/**
 * Traps the keyboard focus in the modal when its open, for a11y purposes.
 *
 * @param modal
 */
function trapFocus(modal) {
	const focusableElements = modal.querySelectorAll('a[href], button, iframe, textarea, input, select, [tabindex]:not([tabindex="-1"])');
	const firstElement = focusableElements[0];
	const lastElement = focusableElements[focusableElements.length - 1];

	document.addEventListener('keydown', function (event) {
		if (event.key === 'Tab') {
			if (event.shiftKey) /* Shift + Tab */ {
				if (document.activeElement === firstElement) {
					event.preventDefault();
					lastElement.focus();
				}
			} else /* Tab */ {
				if (document.activeElement === lastElement) {
					event.preventDefault();
					firstElement.focus();
				}
			}
		}
	});
}

/**
 * Sets up the Modal Close Event Handlers, close button, esc key and clicking outside of the modal area
 *
 * @param modal
 */
function setupModalCloseHandlers(modal) {
	const modalContent = modal.querySelector('.modal-content');
	const closeButton = modal.querySelector('.close-button');

	closeButton.addEventListener('click', (event) => {
		event.preventDefault();
		closeModal(modal)
	});

	modal.addEventListener('click', (event) => {
		if (!modalContent.contains(event.target)) {
			closeModal(modal);
		}
	});

	document.addEventListener('keydown', function (event) {
		if (event.key === 'Escape') {
			closeModal(modal);
		}
	});
}

function pauseAllYouTubeVideos() {
	// console.log('pauseAllYouTubeVideos');
	// Target only iframes within the passed panel element
	const iframes = document.querySelectorAll('iframe[src*="youtube.com"]');

	iframes.forEach((iframe) => {
		// Attempt to access the YT.Player object associated with this iframe and pause the video
		const iframeId = iframe.id;
		const player = YT.get(iframeId);
		if (player && typeof player.pauseVideo === 'function') {
			player.pauseVideo();
		} else {
			// Fallback: Reset src to pause the video if the player object isn't accessible
			const src = iframe.src;
			iframe.src = src;
		}
	});
}
